
import React, { useState, useEffect } from 'react';

import { sendPPCSignupEmails } from "../../common/FunctionCalls";

import { paymentProcessor } from "../../planConfig";

// Custom hook to detect screen size for responsiveness
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState('large');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setScreenSize('small');
      } else if (window.innerWidth < 1024) {
        setScreenSize('medium');
      } else {
        setScreenSize('large');
      }
    };

    // Set initial size
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export default function PaidMarketingLandingPage() {
  const screenSize = useScreenSize();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [source, setSource] = useState('');

  // --- Layout Constants based on screen size ---
  const isMobile = screenSize === 'small';
  const isTablet = screenSize === 'medium';
  
  const contentWidth = isMobile ? '100%' : isTablet ? 768 : 1120;
  const padding = isMobile ? 16 : 24;
  const gridColumns = isMobile ? '1fr' : isTablet ? '1fr' : '1fr 1fr';
  const featureColumns = isMobile ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(3, 1fr)';
  const benefitColumns = isMobile ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(3, 1fr)';

  // --- Colors & Styles ---

  const primaryColor = '#1B263B' // MAIN_PANEL_BG / DRAG_N_DROP_TILE_HOVER_BG  i.e. #480266 or #2D1B3F

  const secondaryColor = softenColor('#90BDFF', 0.20); //  TILE_BORDER / INPUT_MODAL_TEXTBOX_BORDER / INPUT_MODAL_HOVER_BG  i.e. #ffc0cb or #D87DBA

  const secondaryColorOriginal = hardenColor('#90BDFF', 0.50); // i.e. #ffc0cb or #D87DBA

// --- Form & Button Styles ---
  const buttonBaseStyle = {
    padding: '14px 18px',
    borderRadius: 12,
    background: '#FF6A3D',
    color: '#fff',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    transition: 'transform .2s, background .2s',
    width: '100%', // Full width on mobile
    fontSize: isMobile ? 16 : 18,
  };

    const buttonBaseStyle2 = {
    padding: '14px 18px',
    borderRadius: 12,
    background: secondaryColor,
    color: '#000000',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    transition: 'transform .2s, background .2s',
    width: '100%', // Full width on mobile
    fontSize: isMobile ? 16 : 18,
  };

  const inputStyle = {
    width: '93%',
    padding: 14,
    fontSize:17,
    borderRadius: 12,
    background: '#ffffff', // keep solid white
    border: '1.5px solid rgba(72,2,102,0.25)', // subtle purple border
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',  // make input stand out
    outline: 'none',
    transition: 'all .2s ease',
  };


  const cardStyle = {
   padding: "8px 18px",
    background: "rgba(255,255,255,0.86)",
    borderRadius: 30,
    border: "1px solid rgba(255,255,255,0.25)",
    padding: 32,
  };


  const featureCardStyle = {
    padding: isMobile ? 16 : 20,
    borderRadius: 16,
    background: "rgba(255,255,255,0.10)",
    boxShadow: '0 10px 20px rgba(0,0,0,.04)',
    border: '1px solid #eee',
  };

  useEffect(() => {
    let queryString = window.location.search;

    try {
        if (queryString) {
            if (queryString === "?s=r") {
                setSource("reddit");
            } else if (queryString === "?s=q") {
                setSource("quora");
            } else if (queryString === "?s=f") {
                setSource("facebook");
            }else if (queryString === "?s=g") {
                setSource("google");
            }
        }
    } catch (error) {
        console.log(error);
    }

}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      setError('Please enter both your name and email.');
      return;
    }
    setError('');

    // Shell function: integrate your email/send logic here
    await sendLead({ name, email });


    

    setSent(true);

    // Small delay to ensure event fires before redirect
    setTimeout(() => {
      window.location.href = 'https://goreqly.com';
    }, 300);

  };

  const sendLead = async ({ name, email }) => {
    // TODO: replace with your API call
    console.log('Lead captured:', { name, email });
    
    await sendPPCSignupEmails(name,email,paymentProcessor,source);

    return;
  };

  function hardenColor(hex, amount) {
  // Convert HEX -> normalized RGB
  hex = hex.replace(/^#/, '');
  let r = parseInt(hex.substring(0, 2), 16) / 255;
  let g = parseInt(hex.substring(2, 4), 16) / 255;
  let b = parseInt(hex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  // Convert RGB → HSL
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  // ---- APPLY the "hardening" ----
  // 1. DARKEN the color
  l = Math.max(0, l - amount * 0.4);

  // 2. INCREASE saturation
  s = Math.min(1, s + amount * 0.5);

  // Convert back HSL → RGB
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1/6) return p + (q - p) * 6 * t;
    if (t < 1/2) return q;
    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
  };

  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;

  r = hue2rgb(p, q, h + 1/3);
  g = hue2rgb(p, q, h);
  b = hue2rgb(p, q, h - 1/3);

  return (
    "#" +
    Math.round(r * 255).toString(16).padStart(2, "0") +
    Math.round(g * 255).toString(16).padStart(2, "0") +
    Math.round(b * 255).toString(16).padStart(2, "0")
  );
}

function softenColor(hex, amount) {
  // Convert HEX -> normalized RGB
  hex = hex.replace(/^#/, '');
  let r = parseInt(hex.substring(0, 2), 16) / 255;
  let g = parseInt(hex.substring(2, 4), 16) / 255;
  let b = parseInt(hex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  // Convert RGB → HSL
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  // ---- APPLY the universal "softening" ----
  // 1. Increase lightness
  l = Math.min(1, l + amount * 0.4);

  // 2. Reduce saturation
  s = Math.max(0, s - amount * 0.5);

  // Convert HSL → RGB → Hex again
  h = h;

  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1/6) return p + (q - p) * 6 * t;
    if (t < 1/2) return q;
    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
  };

  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;

  r = hue2rgb(p, q, h + 1/3);
  g = hue2rgb(p, q, h);
  b = hue2rgb(p, q, h - 1/3);

  return (
    "#" +
    Math.round(r * 255).toString(16).padStart(2, "0") +
    Math.round(g * 255).toString(16).padStart(2, "0") +
    Math.round(b * 255).toString(16).padStart(2, "0")
  );
}


  return (
    <div style={{
      color: '#0e0e0e',
      minHeight: '100vh',
      fontFamily: 'Inter, system-ui, sans-serif',
      // Background Image for visual interest and emotion
      backgroundImage: `url(images/requirements-management-main-background.png)`,  // i.e. beauty-salon-main-background.png
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundAttachment: 'fixed',
      position: 'relative',
    }}>
      {/* Semi-transparent overlay to ensure text readability */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.80)', // Light overlay
        zIndex: 0,
      }}></div>

      <div style={{
        maxWidth: contentWidth,
        margin: '0 auto',
        padding: padding,
        position: 'relative', // Bring content above the overlay
        zIndex: 1,
      }}>
        <header style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: '#ffffff' }} >
            <img src="/images/logo.png" alt="GoReqly logo" style={{ width: 42, height: 42 }} />  {/* i.e. beauty-salon-platform-transparent.png */}
            <b style={{ fontSize: 20 }}>GoReqly®</b>
          </div>
          <button
            style={{ 
              ...buttonBaseStyle2, 
              width: 'auto', // Override full width for header button
              padding: '10px 16px', 
              fontSize: 14 
            }}
            onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.05)', e.currentTarget.style.background = secondaryColorOriginal)}
            onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)', e.currentTarget.style.background = secondaryColor)}
            onClick={() => {
                    document.getElementById('leadForm').scrollIntoView({ behavior: 'smooth' });
                  }}
          >
            Get Free Access & 70% Off
          </button>
        </header>

        <section id="main-hero" style={{ 
          display: 'grid', 
          gridTemplateColumns: gridColumns, 
          gap: isMobile ? 32 : 48, 
          alignItems: 'center', 
          padding: isMobile ? '32px 0' : '48px 0',
        }}>
          {/* Main Content / USP */}
          <div>
            <div style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: 8, 
              padding: '8px 16px', 
              borderRadius: 999, 
              background: secondaryColor, 
              color: primaryColor, 
              opacity: 0.7,
              fontWeight: 700, 
              fontSize: isMobile ? 14 : 16,
            }}>
              🎁 Exclusive Offer: Free Access + 70% Off First Month
            </div>
            <div 
            style={{
                display: "inline-block",
                padding: "8px 18px",
                marginTop: "8px",
                background: "rgba(0, 0, 0, 0.5)"
              }}
            >
            <h1 style={{ 
              fontSize: isMobile ? 36 : 48, 
              lineHeight: 1.1, 
              margin: '16px 0 12px',
              color: "#ffffff" 
            }}>
              Optimize Your Workflow — <span style={{ color: secondaryColor }}>The Smarter Way</span> to Manage Requirements
            </h1>
            <p style={{ fontSize: 18, maxWidth: 520, opacity: 0.9,color: "#ffffff"  }}>
              The ultimate Requirements Management platform to streamline project workflows, enhance team collaboration, and ensure successful delivery, powered by <b>AI Assistant</b>.  Enter your best email and we'll send your <b>70% off first month coupon instantly.</b>
            </p>
            </div>
            {/* Feature Cards adapted for mobile */}
            <div style={{ display: 'grid', gridTemplateColumns: featureColumns, gap: 16, marginTop: 18 }}>
              {[
                { title: 'Effortless Requirement Capture', desc: 'Capture and track requirements with ease, boosting team alignment.' },
                { title: 'Real-Time Collaboration Hub', desc: 'Enhance team collaboration with instant updates and shared insights.' },
                { title: 'Streamlined Progress Tracking', desc: 'Monitor project progress seamlessly, ensuring timely delivery.' },
              ].map((f, i) => (
                <div key={i} style={featureCardStyle}>
                  <h4 style={{ margin: '0 0 4px', fontSize: isMobile ? 16 : 18, color: hardenColor(secondaryColor, 0.95), fontWeight:'bold' }}>{f.title}</h4>
                  <p style={{ color: '#fff', fontSize: isMobile ? 12 : 14, margin: 0 }}>{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Form Section - Prominently Placed Card */}
          <div id="leadForm" style={cardStyle}>
            <div>
              <h3 style={{ margin: '0 0 6px', fontSize: isMobile ? 24 : 28, color: primaryColor }}>Get 70% Off Your First Month</h3>
              <p style={{ margin: '0 0 20px', color: '#000000', fontSize: isMobile ? 14 : 16 }}>Enter your details — we’ll send your coupon and give you instant access. No card required.</p>
              
              <div style={{ marginBottom: 15 }}>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Your Name"
                  style={inputStyle}
                  onFocus={e => {
                    e.currentTarget.style.border = '2px solid #480266';
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(72,2,102,0.25)';
                  }}
                  onBlur={e => {
                    e.currentTarget.style.border = '1.5px solid rgba(72,2,102,0.25)';
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                  }}
                />
              </div>
              
              <div style={{ marginBottom: 20 }}>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Your Best Email"
                  style={inputStyle}
                  onFocus={e => {
                      e.currentTarget.style.border = '2px solid #480266';
                      e.currentTarget.style.boxShadow = '0 0 0 3px rgba(72,2,102,0.25)';
                    }}
                    onBlur={e => {
                      e.currentTarget.style.border = '1.5px solid rgba(72,2,102,0.25)';
                      e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                    }}
                />
              </div>
              
              <button
                onClick={handleSubmit}
                style={buttonBaseStyle}
                onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.03)', e.currentTarget.style.background = '#E65528')}
                onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)', e.currentTarget.style.background = '#FF6A3D')}
              >

               <center>     
                <table>
                  <tr>
                    <td style={{paddingTop:'5px',paddingRight:'5px'}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="22"
                        height="22" 
                        aria-hidden="true"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="10"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                        <path
                          d="M8.5 12.5 11 15l4.5-5"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        </svg>  
                      </td>
                      <td>
                      Get My Coupon & Start Free Access
                      </td>
                      </tr>
                      </table>
                    </center>
              </button>

                    <div style={{paddingLeft:'140px',paddingTop:'10px'}}>
                        <span style={{color:"#8A2BE2"}}>✔</span> Used by 100+ beauty owners<br></br>
                        <span style={{color:"#8A2BE2"}}>✔</span> 256-bit SSL secure form<br></br>
                        <span style={{color:"#8A2BE2"}}>✔</span> No credit card required<br></br>
                      
                    </div>

              {error && <div style={{ color: '#d9534f', marginTop: 10, fontWeight: 500 }}>{error}</div>}
              {sent && <div style={{ color: '#5cb85c', marginTop: 10, fontWeight: 500 }}>Thanks! Check your email — you'll be redirected shortly.</div>}
              
              {/*
              <div style={{ fontSize: 12, color: '#000000', marginTop: 12, textAlign: 'center' }}>
                No credit card required • Instant email delivery • Unsubscribe anytime
              </div>
              */}
            </div>
          </div>
        </section>

        {/* Benefits Section - The GoReqly Difference */}
        <section style={{ 
          marginTop: isMobile ? 32 : 48,
          marginBottom: isMobile ? 32 : 48,
        }}>
          <div style={{
            background: 'white',
            borderRadius: 24,
            padding: isMobile ? '40px 30px' : '10px 10px', //'40px 30px' : '60px 50px'
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          }}>
            <h2 style={{
              textAlign: 'center',
              fontSize: isMobile ? '2em' : '2.8em',
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColorOriginal} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: isMobile ? 30 : 50,
              fontWeight: 700,
            }}>
              The GoReqly Difference
            </h2>

            {/*
      Give mne bullet value props that are strong related to:

saving time

preventing no-shows

making more money

stopping scheduling headaches


Use the following JSON defintion file to get the values. I also one one bullet value to be about AI and another that let them know that this is a new app and not the same old stuff:

Each bullet value needs to be 40 characters or less. I need 8 bullet values.

            */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr' : '1fr 1fr 1fr',
              gap: isMobile ? 20 : 40,
              alignItems: 'start',
            }}>
              {/* Column 1 */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 24,
              }}>
                {[
                  'End requirement chaos today',
                  'Boost team synergy instantly',
                  'Track changes, guarantee clarity',
                  'Simplify workflows in minutes'
                ].map((text, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 15,
                      padding: 20,
                      background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%)',
                      borderRadius: 12,
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 10px 25px rgba(102, 126, 234, 0.2)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <div style={{
                      minWidth: 28,
                      width: 28,
                      height: 28,
                      background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColorOriginal} 100%)`,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: 16,
                      fontWeight: 'bold',
                      marginTop: 2,
                    }}>
                      ✓
                    </div>
                    <div style={{
                      color: '#2d3748',
                      fontSize: '1.05em',
                      lineHeight: 1.5,
                      fontWeight: 500,
                    }}>
                      {text}
                    </div>
                  </div>
                ))}
              </div>

              {/* Column 2 */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 24,
              }}>
                {[
                  'Effortless task management now',
                  'Deliver results with precision',
                  'AI handles the busy work for you',
                   'A fresh, modern salon app for '+(new Date().getFullYear())
                ].map((text, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 15,
                      padding: 20,
                      background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%)',
                      borderRadius: 12,
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 10px 25px rgba(102, 126, 234, 0.2)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <div style={{
                      minWidth: 28,
                      width: 28,
                      height: 28,
                      background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColorOriginal} 100%)`,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: 16,
                      fontWeight: 'bold',
                      marginTop: 2,
                    }}>
                      ✓
                    </div>
                    <div style={{
                      color: '#2d3748',
                      fontSize: '1.05em',
                      lineHeight: 1.5,
                      fontWeight: 500,
                    }}>
                      {text}
                    </div>
                  </div>
                ))}
              </div>

              {/* Column 3 - CTA Box */}
              <div style={{
                background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColorOriginal} 100%)`,
                borderRadius: 16,
                padding: isMobile ? '30px 25px' : '35px 30px',
                color: 'white',
                boxShadow: `0 10px 30px ${primaryColor}66`,
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  marginBottom: 25,
                  fontSize: '1.3em',
                  fontWeight: 700,
                }}>
                  <span style={{ fontSize: '1.8em' }}>🎁</span>
                  <span>What you'll receive instantly:</span>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 18,
                }}>
                  {[
                    '70% off your first month with your exclusive coupon.',
                    'Instant email delivery of your coupon.',
                    'Immediate access to the GoReqly app — no credit card required.',
                  ].map((text, i) => (
                    <div key={i} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 12,
                    }}>
                      <div style={{
                        minWidth: 8,
                        width: 8,
                        height: 8,
                        background: 'white',
                        borderRadius: '50%',
                        marginTop: 8,
                      }}></div>
                      <div style={{
                        fontSize: '1.05em',
                        lineHeight: 1.6,
                        opacity: 0.95,
                      }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  style={{
                    marginTop: 25,
                    width: '100%',
                    padding: '15px 30px',
                    background: 'white',
                    color: primaryColor,
                    border: 'none',
                    borderRadius: 10,
                    fontSize: '1.1em',
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                  }}
                  onClick={() => {
                    document.getElementById('leadForm').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section style={{ 
          display: 'grid', 
          gridTemplateColumns: benefitColumns, 
          gap: isMobile ? 16 : 24, 
          marginTop: isMobile ? 16 : 32 
        }}>
          {[
            { quote: '"Our projects deliver on time now, thanks to GoReqly\'s precise tracking."', person: 'James, Project Manager' },
            { quote: '"Version Control saved us from costly errors on multiple occasions."', person: 'Lisa, DevOps Engineer' },
            { quote: '"Agile Boards made our team adapt faster, a game changer for us."', person: 'Thomas, Scrum Master' }
          ].map((t, i) => (
            <div key={i} style={{ 
              padding: isMobile ? 16 : 20, 
              borderRadius: 20, 
              background: '#fff', 
              boxShadow: '0 10px 20px rgba(0,0,0,.05)',
              borderLeft: `4px solid ${primaryColor}`,
            }}>
              <b style={{ fontSize: isMobile ? 14 : 16, lineHeight: 1.4 }}>{t.quote}</b>
              <div style={{ fontSize: 12, color: '#777', marginTop: 8 }}>— **{t.person}**</div>
            </div>
          ))}
        </section>

        {/* CTA Banner at the bottom */}
        <section style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 16 : 24, 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          padding: isMobile ? 24 : 32, 
          marginTop: isMobile ? 24 : 40, 
          background: primaryColor, 
          borderRadius: 24, 
          boxShadow: '0 15px 30px rgba(0,0,0,.15)',
          textAlign: isMobile ? 'center' : 'left'
        }}>
          <div>
            <h3 style={{ margin: '0 0 8px', color: '#fff', fontSize: isMobile ? 22 : 28 }}>Ready to streamline your organization?</h3>
            <div style={{ color: '#fff', opacity: 0.8, fontSize: isMobile ? 16 : 18 }}>Get the app now — your <b style={{ color: secondaryColor }}>70% off</b> coupon lands via email.</div>
          </div>
          <button
            style={{ 
              ...buttonBaseStyle,
              background: secondaryColor,
              color: primaryColor,
              width: isMobile ? '100%' : 'auto', // Full width on mobile
            }}
            onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.03)', e.currentTarget.style.background = '#dbdbdb')}
            onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)', e.currentTarget.style.background = secondaryColor)}
            onClick={() => {
                    document.getElementById('leadForm').scrollIntoView({ behavior: 'smooth' });
                  }}
          >
            ✨ Get Your Discount Now
          </button>
        </section>

        {/* Footer */}
        <footer style={{ color: '#555', padding: '28px 0', fontSize: 14, textAlign: 'center' }}>
          © {new Date().getFullYear()} GoReqly • https://goreqly.com • <span style={{ color: '#777' }}>All rights reserved.</span>
        </footer>
      </div>
    </div>
  );
}